import { useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { SectionWrapper, TitleWrapper } from "../../../styles/sectionStyles";
import { SkillList } from "./SkillList";
import Skills from "../../../data/Skills.json";

// imgs:
import TuanTechStackImg from "../../../assets/TuanTechStack.png";
import OnionArchitecture from "../../../assets/OnionArchitecture.jpg";
import UnitOfWorkAndRepository from "../../../assets/Unit-Of-Work and-Repository-Pattern.png";

export const SkillsContainer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <SectionWrapper>
      <TitleWrapper>SKILLS</TitleWrapper>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <SkillList type="hardSkills" skills={Skills.hardSkills} />
          </Grid>
          <Grid item xs={12} md={6}>
            <SkillList type="softSkills" skills={Skills.softSkills} />
          </Grid>
          
        </Grid>
      </Box>
          {/*<img style={{ boxShadow: "rgba(0, 0, 0, 0.25) 0px 25px 50px -12px", borderRadius:"10px"}} width="70%" src={TuanTechStackImg} alt="TuanTechStack" />*/}
          <h2>Onion architecture to ease maintenance pain as the API grows!</h2>
          <img style={{ boxShadow: "rgba(0, 0, 0, 0.25) 0px 25px 50px -12px", borderRadius: "10px" }} width="70%" src={OnionArchitecture} alt="OnionArchitecture" />

          <h2>UnitOfWork + Repository pattern for better Data Access Layer</h2>
          <p>This help dev team to reduce the duplication of classes by using generic repository.</p>
          <img style={{ boxShadow: "rgba(0, 0, 0, 0.25) 0px 25px 50px -12px", borderRadius: "10px" }} width="70%" src={UnitOfWorkAndRepository} alt="UnitOfWorkAndRepository" />
    </SectionWrapper>
  );
};
